export const CONTACT_PHONE_E164 = "+923172032615";
export const CONTACT_PHONE_DISPLAY = "+92 317 2032615";
export const WHATSAPP_URL = "https://wa.me/message/LHNVMYRX2XF7M1";